import moment from "moment";

import {
	NOTIFICATION_SET_VALUE,
	NOTIFICATION_IS_SAVING_PUSH
} from 'actions/const';

const initialState = {
	resetState: false,
	errors: {},
	isOpenDatePicker: false,
	isSending: false,
	isUploadingCSVFile: false,
	showModalConfirmation: false,

	notifCount: 0,
	notifCountWithSchedule: 0,
	notifCountPending: 0,

	sendMode: {
		value: "TEST",
		label: "TEST"
	},
	sendModeOptions: [
		{
			value: "TEST",
			label: "TEST"
		},
		{
			value: "LIVE",
			label: "LIVE"
		},
	],
	userType: {
		value: 'MEMBER',
		label: 'MEMBER'
	},
	userTypeOptions: [
		{
			value: 'ALL',
			label: 'ALL'
		}, {
			value: 'MEMBER',
			label: 'MEMBER'
		}, {
			value: 'NON-MEMBER',
			label: 'NON-MEMBER'
		}
	],
	cardType: [],
	cardTypeOptions: [],
	ageBracket: [35, 45],
	gender: null,
	genderOptions: [
		{
			value: 'ALL',
			label: 'All'
		}, {
			value: 'MALE',
			label: 'Male'
		}, {
			value: 'FEMALE',
			label: 'Female'
		}
	],
	device: {
		value: 'ALL',
		label: 'ALL'
	},
	deviceOptions: [
		{
			value: 'ALL',
			label: 'ALL'
		}, {
			value: 'ANDROID',
			label: 'ANDROID'
		}, {
			value: 'IOS',
			label: 'IOS'
		}
	],
	screen: null,
	screenOptions: [],
	browser: null,
	browserOptions: [
		{
			value: 'INTERNAL',
			label: 'INTERNAL'
		}, {
			value: 'EXTERNAL',
			label: 'EXTERNAL'
		}
	],
	specificUser: [],
	specificUserOptions: [],
	blacklistedUser: [],
	blacklistedUserOptions: [],

	subject: "",
	url: "",
	message: "",
	isSendNow: true,
	scheduleDateTimeNotif: moment()
};

function reducer(state = initialState, action) {
	switch (action.type) {

		case NOTIFICATION_SET_VALUE:
			if (typeof action.payload.resetState !== "undefined" && action.payload.resetState) {
				action.payload = {...initialState};
			}
			return Object.assign({}, state, action.payload);
			break;
		case NOTIFICATION_IS_SAVING_PUSH:
			return Object.assign({}, state, {
				isSending: !isSending
			});
			break;
		default:
			{
				/* Return original state if no actions were consumed. */
				return state;
			}
	}
}

module.exports = reducer;



// WEBPACK FOOTER //
// ./reducers/Notifications.js